import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {patch} from '@ngxs/store/operators';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {JsonApiResponse} from '@tisa-group/cdk';
import {LoadPlaylist} from '@store/playlist/playlist.actions';
import {UmpireOttPlaylist} from '@tisa-group/models';
import {OttClientPlaylistService} from '@tisa-group/core/api/umpire/ott-client-playlist/ott-client-playlist.service';

export type PlaylistStateModel = Record<string, JsonApiResponse<UmpireOttPlaylist>>;

@State<PlaylistStateModel>({
  name: 'Playlist',
  defaults: {},
})
@Injectable()
export class PlaylistState {
  @Action(LoadPlaylist)
  loadEvent(
    ctx: StateContext<PlaylistStateModel>,
    action: LoadPlaylist,
  ): Observable<JsonApiResponse<UmpireOttPlaylist>> | JsonApiResponse<UmpireOttPlaylist> {
    const statePlaylist = ctx.getState()[action.slug];

    if (statePlaylist) {
      return statePlaylist;
    }

    return this.playlistService
      .fetch(action.slug, {
        include: ['tags', 'image'].join(','),
      })
      .pipe(
        tap(res =>
          ctx.setState(
            patch({
              [res.data.slug as string]: res,
            }),
          ),
        ),
      );
  }

  static getPlaylistBySlug(
    slug: string,
  ): (state: PlaylistStateModel) => JsonApiResponse<UmpireOttPlaylist> {
    return createSelector<
      (state: PlaylistStateModel) => JsonApiResponse<UmpireOttPlaylist>
    >([PlaylistState], state => {
      return state[slug];
    });
  }

  constructor(readonly playlistService: OttClientPlaylistService) {}
}
